export default __webpack_public_path__ + "static/media/image1.8bb61b62.png";